const ExclamatoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3"
      height="15"
      viewBox="0 0 3 15"
      fill="none"
    >
      <path
        d="M1.95002 1V9M2.00002 13V13.1H1.90002V13H2.00002Z"
        stroke="#F97316"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ExclamatoryIcon;
